import { render, staticRenderFns } from "./RgpTagSelectorGroup.vue?vue&type=template&id=051bff9c&scoped=true&"
import script from "./RgpTagSelectorGroup.vue?vue&type=script&lang=js&"
export * from "./RgpTagSelectorGroup.vue?vue&type=script&lang=js&"
import style0 from "./RgpTagSelectorGroup.vue?vue&type=style&index=0&id=051bff9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051bff9c",
  null
  
)

export default component.exports